/* Syrup Oracle: Tiki Calendar — renders tikibound.com's calendar feed on BG
   Reynolds. Client-side fetch (feed is CORS-open). Full page = an interactive
   month grid (event days highlighted, prev/next navigation) with that month's
   events, active regions, and almanac listed below. Homepage teaser = the next
   few events as a compact list. All outbound links carry a bgreynolds UTM.
   Fails soft: if the feed is unreachable, the mount shows a short line + a link
   to tikibound.com. */
(function () {
  'use strict';
  var FEED = 'https://tikibound.com/calendar.json';
  var ICS = 'https://tikibound.com/tikibound.ics';
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
    'August', 'September', 'October', 'November', 'December'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DOW = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function utmize(url) {
    if (!url) return url;
    try {
      var u = new URL(url, 'https://tikibound.com');
      u.searchParams.set('utm_source', 'bgreynolds');
      u.searchParams.set('utm_medium', 'referral');
      u.searchParams.set('utm_campaign', 'tiki-calendar');
      return u.toString();
    } catch (e) { return url; }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function parseDate(s) { var p = s.split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }
  function fmtKey(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function evHref(e) { return e.url ? utmize(e.url) : null; }

  /* ---------- compact US locator map (inline SVG, no external tiles) ----------
     Equirectangular projection; MAP_W/H chosen so the aspect matches the US at
     mid-latitude, so the hand-simplified outline and the lat/lng pins share one
     coordinate space and always align. */
  var MAP_W = 600, MAP_H = 320;
  var LON0 = -125, LON1 = -66.5, LAT0 = 24.5, LAT1 = 49.5;
  function project(lon, lat) {
    return [(lon - LON0) / (LON1 - LON0) * MAP_W, (LAT1 - lat) / (LAT1 - LAT0) * MAP_H];
  }
  var US_OUTLINE = [
    [-124.6, 48.3], [-124.1, 46.2], [-124.0, 43.3], [-124.4, 40.3], [-122.4, 37.2], [-120.5, 34.5], [-118.2, 33.8], [-117.1, 32.5],
    [-114.6, 32.6], [-111.0, 31.3], [-108.2, 31.8], [-106.4, 31.8], [-104.9, 30.6], [-102.3, 29.9], [-99.5, 27.6], [-97.4, 25.9],
    [-96.5, 28.4], [-94.8, 29.3], [-92.3, 29.6], [-90.5, 29.1], [-89.2, 29.3], [-88.9, 30.3], [-87.5, 30.3], [-85.7, 29.9], [-84.3, 30.0], [-83.6, 29.4],
    [-82.8, 28.0], [-82.1, 26.7], [-81.1, 25.3], [-80.4, 25.2], [-80.1, 26.5], [-80.6, 28.3], [-81.2, 29.7], [-81.4, 30.7],
    [-80.9, 32.0], [-78.6, 33.9], [-76.3, 35.0], [-75.5, 35.6], [-75.9, 37.2], [-75.0, 38.5], [-74.0, 40.4], [-71.9, 41.3], [-70.6, 41.7], [-70.2, 43.3], [-67.2, 44.6], [-67.1, 45.2], [-69.2, 47.4],
    [-71.5, 45.1], [-76.5, 44.2], [-82.7, 42.0], [-84.5, 46.2], [-88.5, 48.2], [-95.2, 49.0], [-104.0, 49.0], [-114.0, 49.0], [-123.0, 49.0]
  ];
  var US_PATH = 'M' + US_OUTLINE.map(function (pt) {
    var p = project(pt[0], pt[1]); return p[0].toFixed(1) + ',' + p[1].toFixed(1);
  }).join('L') + 'Z';

  function mapSvg(evs) {
    var seen = {}, pins = [];
    evs.forEach(function (e) {
      if (e.lat == null || e.lng == null) return;
      var key = e.city || (e.lat + ',' + e.lng);
      if (seen[key]) return; seen[key] = 1;
      var p = project(e.lng, e.lat);
      pins.push({ x: p[0], y: p[1], city: e.city || '' });
    });
    var pinEls = pins.map(function (p) {
      var x = p.x.toFixed(1), y = p.y.toFixed(1);
      return '<g class="so-tc__pin"><circle class="so-tc__pin-halo" cx="' + x + '" cy="' + y + '" r="7"/>' +
        '<circle class="so-tc__pin-dot" cx="' + x + '" cy="' + y + '" r="3.5"/><title>' + esc(p.city) + '</title></g>';
    }).join('');
    var aria = pins.length
      ? 'Map of active tiki locations this month: ' + pins.map(function (p) { return p.city; }).join(', ')
      : 'US map, no tiki events this month';
    return '<svg class="so-tc__map" viewBox="0 0 ' + MAP_W + ' ' + MAP_H + '" role="img" aria-label="' + esc(aria) + '">' +
      '<path class="so-tc__map-land" d="' + US_PATH + '"/>' + pinEls + '</svg>';
  }

  /* ---------- teaser (homepage): next N events as a list ---------- */
  function renderEventsList(events, limit) {
    var live = events.filter(function (e) { return e.status !== 'dormant'; });
    var dated = live.filter(function (e) { return e.start; });
    var tba = live.filter(function (e) { return !e.start; });
    var ordered = dated.concat(tba);
    if (limit) ordered = ordered.slice(0, limit);
    if (!ordered.length) return '<p class="so-tc__empty">No gatherings on the horizon just now — check back soon.</p>';
    return '<ul class="so-tc__events">' + ordered.map(eventRow).join('') + '</ul>';
  }
  function eventRow(e) {
    var href = evHref(e);
    var name = href
      ? '<a class="so-tc__name" href="' + esc(href) + '" target="_blank" rel="noopener">' + esc(e.name) + '</a>'
      : '<span class="so-tc__name">' + esc(e.name) + '</span>';
    var tba = e.status === 'tba' ? ' <span class="so-tc__tba">dates TBA</span>' : '';
    var city = e.city ? '<span class="so-tc__city">' + esc(e.city) + '</span>' : '';
    var blurb = e.blurb ? '<span class="so-tc__blurb">' + esc(e.blurb) + '</span>' : '';
    return '<li class="so-tc__event" id="' + (e.id ? 'ev-' + esc(e.id) : '') + '">' +
      '<span class="so-tc__when">' + esc(e.label || 'Coming soon') + '</span>' +
      '<span class="so-tc__what">' + name + tba + city + blurb + '</span></li>';
  }

  /* ---------- full page: interactive month calendar ---------- */
  function CalendarView(mount, data) {
    var events = (data.events || []).filter(function (e) { return e.status !== 'dormant'; });
    var almanac = data.almanac || {};
    var today = new Date();
    var view = { y: today.getFullYear(), m: today.getMonth() };

    // index every day covered by a dated event
    var byDate = {};
    events.forEach(function (e) {
      if (!e.start) return;
      var s = parseDate(e.start), en = e.end ? parseDate(e.end) : s, g = 0;
      var d = new Date(s);
      while (d <= en && g < 120) { var k = fmtKey(d); (byDate[k] = byDate[k] || []).push(e); d.setDate(d.getDate() + 1); g++; }
    });
    var tba = events.filter(function (e) { return !e.start; });

    function monthEvents(y, m) {
      var mS = new Date(y, m, 1), mE = new Date(y, m + 1, 0);
      return events.filter(function (e) {
        if (!e.start) return false;
        var s = parseDate(e.start), en = e.end ? parseDate(e.end) : s;
        return s <= mE && en >= mS;
      }).sort(function (a, b) { return a.start < b.start ? -1 : a.start > b.start ? 1 : 0; });
    }
    function nextEventFrom(y, m) {
      var floor = new Date(y, m, 1);
      var up = events.filter(function (e) { return e.start; })
        .map(function (e) { return parseDate(e.end || e.start); })
        .filter(function (d) { return d >= floor; })
        .sort(function (a, b) { return a - b; });
      return up.length ? up[0] : null;
    }

    function grid(y, m) {
      var startDow = new Date(y, m, 1).getDay();
      var days = new Date(y, m + 1, 0).getDate();
      var todayKey = fmtKey(today);
      var h = '<table class="so-tc__grid"><thead><tr>';
      DOW.forEach(function (d) {
        h += '<th scope="col"><span aria-hidden="true">' + d.slice(0, 1) + '</span><span class="so-tc__sr">' + d + '</span></th>';
      });
      h += '</tr></thead><tbody><tr>';
      var col = 0, i;
      for (i = 0; i < startDow; i++) { h += '<td class="so-tc__cell so-tc__cell--pad"></td>'; col++; }
      for (var day = 1; day <= days; day++) {
        var key = y + '-' + pad(m + 1) + '-' + pad(day);
        var evs = byDate[key] || [];
        var alm = almanac[pad(m + 1) + '-' + pad(day)];
        var cls = 'so-tc__cell';
        if (evs.length) cls += ' so-tc__cell--event';
        if (alm) cls += ' so-tc__cell--alm';
        if (key === todayKey) cls += ' so-tc__cell--today';
        if (evs.length) {
          var names = evs.map(function (e) { return e.name; }).join(', ');
          h += '<td class="' + cls + '"><button type="button" class="so-tc__cellbtn" data-day="' + key + '"' +
            ' title="' + esc(names) + '" aria-label="' + day + ': ' + esc(names) + '">' +
            '<span class="so-tc__daynum">' + day + '</span><span class="so-tc__evdot" aria-hidden="true"></span></button></td>';
        } else {
          var t = alm ? alm[0].label : '';
          h += '<td class="' + cls + '"' + (t ? ' title="' + esc(t) + '"' : '') + '>' +
            '<span class="so-tc__daynum">' + day + '</span>' +
            (alm ? '<span class="so-tc__almdot" aria-hidden="true"></span>' : '') + '</td>';
        }
        col++;
        if (col === 7) { h += '</tr>'; if (day < days) h += '<tr>'; col = 0; }
      }
      if (col !== 0) { while (col < 7) { h += '<td class="so-tc__cell so-tc__cell--pad"></td>'; col++; } h += '</tr>'; }
      return h + '</tbody></table>';
    }

    function regions(evs) {
      var seen = {}, list = [];
      evs.forEach(function (e) { if (e.city && !seen[e.city]) { seen[e.city] = 1; list.push(e.city); } });
      if (!list.length) return '';
      return '<div class="so-tc__regions"><span class="so-tc__regions-label">Active this month</span>' +
        list.map(function (c) { return '<span class="so-tc__region">' + esc(c) + '</span>'; }).join('') + '</div>';
    }

    function monthAlmanac(m) {
      var mm = pad(m + 1), out = [];
      Object.keys(almanac).sort().forEach(function (k) {
        if (k.slice(0, 2) !== mm) return;
        var day = parseInt(k.slice(3), 10);
        almanac[k].forEach(function (it) {
          var txt = esc(it.label);
          if (it.url) txt = '<a href="' + esc(utmize(it.url)) + '" target="_blank" rel="noopener">' + txt + '</a>';
          out.push('<li class="so-tc__alm-item"><span class="so-tc__alm-date">' + MON[m] + ' ' + day + '</span> ' +
            txt + (it.year ? ' <span class="so-tc__year">' + esc(it.year) + '</span>' : '') + '</li>');
        });
      });
      if (!out.length) return '';
      return '<div class="so-tc__section"><div class="so-rule so-cv__rule"><span>This month in tiki history</span></div>' +
        '<ul class="so-tc__alm">' + out.join('') + '</ul></div>';
    }

    var LEGEND = '<p class="so-tc__legend">' +
      '<span class="so-tc__lg so-tc__lg--event"></span>Event days' +
      '<span class="so-tc__lg so-tc__lg--alm"></span>Tiki history' +
      '<span class="so-tc__lg so-tc__lg--today"></span>Today</p>';

    function paint() {
      var evs = monthEvents(view.y, view.m);
      var body = '<div class="so-tc__cal-main">' +
        '<div class="so-tc__cal-left">' + grid(view.y, view.m) + LEGEND + '</div>' +
        '<div class="so-tc__cal-right">' + mapSvg(evs) + regions(evs) + '</div>' +
        '</div>';
      body += '<div class="so-tc__section"><div class="so-rule so-cv__rule"><span>' +
        (evs.length ? 'Gatherings this month' : 'This month') + '</span></div>';
      if (evs.length) {
        body += '<ul class="so-tc__events">' + evs.map(eventRow).join('') + '</ul>';
      } else {
        var nxt = nextEventFrom(view.y, view.m);
        body += '<p class="so-tc__empty">No tiki events this month.' +
          (nxt ? ' <button type="button" class="so-tc__jump" data-jump="' + nxt.getFullYear() + '-' + nxt.getMonth() + '">Jump to the next gathering &rsaquo;</button>' : '') + '</p>';
      }
      body += '</div>';
      body += monthAlmanac(view.m);
      mount.querySelector('[data-cal-body]').innerHTML = body;
      mount.querySelector('[data-cal-label]').textContent = MONTHS[view.m] + ' ' + view.y;
      var todayBtn = mount.querySelector('[data-cal-nav="today"]');
      if (todayBtn) todayBtn.hidden = (view.y === today.getFullYear() && view.m === today.getMonth());
    }

    function step(delta) {
      var d = new Date(view.y, view.m + delta, 1);
      view.y = d.getFullYear(); view.m = d.getMonth(); paint();
    }

    // shell
    var subscribe = mount.getAttribute('data-subscribe') === 'true' ? subscribeHtml() : '';
    mount.innerHTML =
      '<div class="so-tc__cal">' +
        '<div class="so-tc__cal-nav">' +
          '<button type="button" class="so-tc__navbtn" data-cal-nav="prev" aria-label="Previous month">&lsaquo;</button>' +
          '<span class="so-tc__cal-month" data-cal-label aria-live="polite"></span>' +
          '<button type="button" class="so-tc__navbtn" data-cal-nav="next" aria-label="Next month">&rsaquo;</button>' +
          '<button type="button" class="so-tc__today" data-cal-nav="today" hidden>Today</button>' +
        '</div>' +
        '<div data-cal-body></div>' +
      '</div>' +
      subscribe +
      (tba.length ? '<div class="so-tc__section so-tc__tba-block"><div class="so-rule so-cv__rule"><span>Still to be dated</span></div>' +
        '<ul class="so-tc__events">' + tba.map(eventRow).join('') + '</ul></div>' : '') +
      '<p class="so-tc__credit">Calendar kept by <a href="' + esc(utmize('https://tikibound.com')) +
        '" target="_blank" rel="noopener">Tikibound</a>' + (data.generated ? ' &middot; updated ' + esc(data.generated) : '') + '.</p>';

    mount.addEventListener('click', function (e) {
      var nav = e.target.closest('[data-cal-nav]');
      if (nav) {
        var k = nav.getAttribute('data-cal-nav');
        if (k === 'prev') step(-1); else if (k === 'next') step(1);
        else { view.y = today.getFullYear(); view.m = today.getMonth(); paint(); }
        return;
      }
      var jump = e.target.closest('[data-jump]');
      if (jump) { var p = jump.getAttribute('data-jump').split('-'); view.y = +p[0]; view.m = +p[1]; paint(); return; }
      var day = e.target.closest('[data-day]');
      if (day) {
        var kk = day.getAttribute('data-day');
        var evs = byDate[kk] || [];
        if (evs[0] && evs[0].id) {
          var row = mount.querySelector('#ev-' + evs[0].id);
          if (row) { row.scrollIntoView({ behavior: 'smooth', block: 'center' }); row.classList.add('so-tc__event--flash'); setTimeout(function () { row.classList.remove('so-tc__event--flash'); }, 1600); }
        }
      }
    });
    paint();
  }

  function subscribeHtml() {
    var webcal = ICS.replace(/^https?:/, 'webcal:');
    return '<p class="so-tc__subscribe">' +
      '<a class="so-tc__sub-btn" href="' + esc(webcal) + '">Add to your calendar</a> ' +
      '<a class="so-tc__sub-alt" href="' + esc(utmize('https://tikibound.com')) + '" target="_blank" rel="noopener">or browse every event at Tikibound &rsaquo;</a></p>';
  }
  function fail(mount) {
    mount.innerHTML = '<p class="so-tc__empty">The tiki calendar is resting. ' +
      '<a href="' + esc(utmize('https://tikibound.com')) + '" target="_blank" rel="noopener">See what’s on at Tikibound &rsaquo;</a></p>';
  }

  function render(mount, data) {
    var mode = mount.getAttribute('data-so-tikical') || 'full';
    if (mode === 'teaser') {
      var limit = parseInt(mount.getAttribute('data-count'), 10) || 3;
      var html = renderEventsList(data.events || [], limit);
      var full = mount.getAttribute('data-full-url');
      if (full) html += '<p class="so-tc__more"><a href="' + esc(full) + '">See the full tiki calendar &rsaquo;</a></p>';
      mount.innerHTML = html;
    } else {
      CalendarView(mount, data);
    }
  }

  function boot() {
    var mounts = document.querySelectorAll('[data-so-tikical]');
    if (!mounts.length) return;
    var cb = Math.floor(Date.now() / 3600000);
    fetch(FEED + '?v=' + cb, { mode: 'cors' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (data) {
        Array.prototype.forEach.call(mounts, function (m) { try { render(m, data); } catch (e) { fail(m); } });
      })
      .catch(function () { Array.prototype.forEach.call(mounts, fail); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
